<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

var marked = require('marked');

var icons = {
  danger: '<i class="fas fa-skull-crossbones"></i>',
  warning: '<i class="fas fa-hand-paper"></i>',
  info: '<i class="fas fa-info-circle"></i>',
  primary: '<i class="fas fa-lightbulb"></i>',
  default: '<i class="fas fa-bell"></i>',
  success: '<i class="fas fa-check-circle"></i>',
};

export default {
  page: {
    title: 'Docs',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Docs',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Docs', active: true, },
      ],
      dsbl_btn: false,

      view_doc: {id:'',title:'',body:''},
      // view_section: [],

      default_new_section: {title:''},
      new_section: {},

      default_new_doc: {title:''},
      new_doc: {},

      loading: true,
      results: [],
      filters: {
        total: 0,
        withs: {
          user: {total: 0},
          docs: {total: 0},
        },
      },
    }
  },
  computed: {
    htmlContent: function () {
      // var temp = marked(this.content);
      // var matches = temp.split('{').filter(function(v){return v.indexOf('}') > -1}).map(function(value){return value.split('}')[0]; })
      // for(var i in matches){ temp = temp.replace("{"+matches[i]+"}", icons[matches[i]]); }
      if(!this.view_doc.body) { this.view_doc.body = ""; }
      var $html = $('<div />',{html:marked(this.view_doc.body)});

      var qnav = "<ul class='docs_qnav'>";
      $html.find('h2').each(function(){
        var str = $(this).html();
        $(this).html("<a name='" + str + "'></a>" + str);
        qnav += "<li><a href='#" + str + "'>" + str + "</a></li>";
      });
      qnav += "</ul>";

      $html.find('blockquote').each(function(){
        var str = $(this).html(), match = str.match(/\{(.*?)\}/);
        $(this).addClass('alert alert-'+match[1]);
        $(this).html(str.replace(/\{(.*?)\}/, icons[match[1]]));
      });

      return qnav+$html.html();
    },
  },
  created() {
    this.new_section = JSON.parse(JSON.stringify(this.default_new_section));
    this.new_doc = JSON.parse(JSON.stringify(this.default_new_doc));
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/docssections/fetch', {params: this.filters}).then(res => {
        console.log(res);
        this.results = res.data.data;

        var count = 0;
        for(var i in this.results) { for(var j in this.results[i].docs) { count++;
          if(count == 1) { this.view_doc = this.results[i].docs[j]; }
          if(this.$route.params.id && this.results[i].docs[j].id == this.$route.params.id) { this.view_doc = this.results[i].docs[j]; }
        } }

        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    add_doc() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      this.$http.post('/api/docs/store', this.new_doc).then(res => {
        // console.log(res);
        this.new_doc = JSON.parse(JSON.stringify(this.default_new_doc));
        this.$router.push('/docs/'+res.data.id);
        this.$refs.modal_add_doc.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    update_doc() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      this.$http.put('/api/docs/update', this.view_doc).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        // this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_doc() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.view_doc.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this Doc?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/docs/delete/'+this.view_doc.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.view_doc = {id:'',title:'',body:''};
              $(".expand_nav").addClass('btn-default'); $(".expand_nav").removeClass('btn-success');
              $('.doc_editor').removeClass('expanded_nav');
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    add_section() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/docssections/store', this.new_section).then(res => {
        // console.log(res);
        this.new_section = JSON.parse(JSON.stringify(this.default_new_section));
        this.$refs.modal_add_section.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    update_section() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/docssections/update', this.new_section).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.new_section = JSON.parse(JSON.stringify(this.default_new_section));
        this.$refs.modal_add_section.hide();
        // this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_section() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.new_section.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      if(this.new_section.docs && this.new_section.docs.length > 0) {
        this.$noty.warning('Please move/delete all Docs in this section before attempting to delete'); this.dsbl_btn = false; return;
      }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this section?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/docssections/delete/'+this.new_section.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.new_section = JSON.parse(JSON.stringify(this.default_new_section));
              this.$refs.modal_add_section.hide();
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    change_doc(id) {
      for(var i in this.results) { for(var j in this.results[i].docs) {
        if(this.results[i].docs[j].id == id) { this.view_doc = this.results[i].docs[j]; }
      } }
      window.history.replaceState('', '', '/docs/'+id);
    },
    expand_nav() {
      if($(".doc_editor").hasClass("expanded_nav")) {
        $(".expand_nav").addClass('btn-default'); $(".expand_nav").removeClass('btn-success');
        $('.doc_editor').removeClass('expanded_nav');
      } else {
        $(".expand_nav").addClass('btn-success'); $(".expand_nav").removeClass('btn-default');
        $('.doc_editor').addClass('expanded_nav');
      }
    },
    download_doc() {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.view_doc.body));
      element.setAttribute('download', this.view_doc.title+'.md');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

  }
}
</script>

<template>
  <Layout>
    <div>

      <PageHeader :title="title" :items="items" />

      <b-modal ref="modal_add_section" centered size="md" :title="new_section.id ? 'Update section' : 'Create a section'" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
        <form @submit.prevent="new_section.id ? update_section() : add_section()" method="post">
          <div class="p-3">
            <div class="form-group">
              <label for="">Title <span class="text-danger">*</span></label>
              <input class="form-control" type="text" v-model="new_section.title" required>
            </div>
          </div>
          <footer class="modal-footer modal-footer-custom">
            <button v-if="new_section.id" type="button" class="btn btn-danger mr-auto ml-0" @click="delete_section" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:delete-bin-7-line" /> Delete</button>
            <button type="button" class="btn btn-light" @click="$refs.modal_add_section.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line"></Icon> Save</button>
          </footer>
        </form>
      </b-modal>

      <b-modal ref="modal_add_doc" centered size="md" title="Create a doc" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
        <form @submit.prevent="add_doc" method="post">
          <div class="p-3">
            <div class="form-group">
              <label for="">Title <span class="text-danger">*</span></label>
              <input class="form-control" type="text" v-model="new_doc.title" required>
            </div>
            <div class="form-group">
              <label for="">Section <span class="text-danger">*</span></label>
              <select class="form-control" v-model="new_doc.docs_sections_id" required>
                <option v-for="(item, index) in results" :key="item.id" :value="item.id">{{item.title}}</option>
              </select>
            </div>
          </div>
          <footer class="modal-footer modal-footer-custom">
            <button type="button" class="btn btn-light" @click="$refs.modal_add_doc.hide()" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:close-fill" /> Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line"></Icon> Save</button>
          </footer>
        </form>
      </b-modal>

      <div class="doc_editor" v-show="view_doc.id">
        <button type="button" class="btn btn-lg btn-white expand_nav" name="button" v-tippy title="Expand Doc editor. (Click to toggle open)" @click="expand_nav"><Icon icon="ri:edit-2-line" /></button>
        <button type="button" class="btn btn-primary float-right ml-1" name="button" v-tippy title="Save changes" @click="update_doc" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line"></Icon></button>
        <button type="button" class="btn btn-danger float-right ml-1" name="button" v-tippy title="Delete Doc" @click="delete_doc" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:delete-bin-7-line" /></button>
        <h1>Document Editor</h1>
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="">Title <span class="text-danger">*</span></label>
              <input class="form-control" type="text" v-model="view_doc.title" required>
            </div>
          </div>
          <div class="col-12 col-sm-6"><div class="form-group">
            <label for="">Section <span class="text-danger">*</span></label>
            <select class="form-control" v-model="view_doc.docs_sections_id" required>
              <option v-for="(item, index) in results" :key="item.id" :value="item.id">{{item.title}}</option>
            </select>
          </div>
          </div>
        </div>
        <textarea class="form-control mb-5" v-model="view_doc.body" rows="8"></textarea>
      </div>

      <div class="row mt-4">
        <div class="col-sm-3">
          <div class="card-box p-0 position-relative doc_nav">
            <transition name="fade">
              <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
            </transition>
            <div class="p-1">
              <div class="row m-0 text-nowrap">
                <!-- <div class="col-4 p-1">
                  <button class="btn btn-block btn-light" type="button" v-tippy content="Coming soon"><Icon icon="ri:menu-line" /> Arrange</button>
                </div> -->
                <div class="col-6 p-1 px-0">
                  <button class="btn btn-block btn-success" type="button" @click="new_section = JSON.parse(JSON.stringify(default_new_section)); $refs.modal_add_section.show()" v-tippy content="Add Section"><Icon icon="ri:add-line" /> Section</button>
                </div>
                <div class="col-6 p-1">
                  <button class="btn btn-block btn-success" type="button" @click="new_doc = JSON.parse(JSON.stringify(default_new_doc)); $refs.modal_add_doc.show()" v-tippy content="Add Doc"><Icon icon="ri:add-line" /> Doc</button>
                </div>
              </div>
            </div>
            <hr class="mt-0">
            <ul>
              <li v-for="(item, index) in results" :key="item.id">
                <h2 class="font-weight-bolder">-- <a @click="new_section = JSON.parse(JSON.stringify(item)); $refs.modal_add_section.show()" v-tippy content="Edit Section">{{item.title}}</a></h2>
                <ul>
                  <li v-for="(item2, index2) in item.docs" :key="item2.id" :class="item2.id == view_doc.id ? 'is-active' : ''">
                    <a @click="change_doc(item2.id)" >{{item2.title}}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="card-box p-0 position-relative mb-30" id="print_doc">
            <div class="position-absolute" style="top:10px; right:10px; z-index:90">
              <button type="button" class="btn btn-light ml-1" v-tippy content="Download MD file" @click="download_doc"><Icon icon="ri:download-line" /></button>
              <button type="button" class="btn btn-light print_target ml-1" target="print_doc" v-tippy content="Print"><Icon icon="ri:printer-line" /></button>
            </div>
            <div v-if="view_doc.id && !view_doc.body" class="alert alert-warning">Start creating this document by hovering over the pencil icon on the top right.</div>
            <div class="docs" v-html="htmlContent"></div>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>

<style>
  .doc_editor {
    position: fixed;
    top: 0px;
    right: -750px;
    width: 750px;
    background: white;
    font-weight: 400;
    bottom: 0px;
    padding: 20px;
    z-index: 1000;
    -webkit-transition:all .7s ease-in-out; -moz-transition:all .7s ease-in-out; transition:all .7s ease-in-out;
    -webkit-box-shadow:0 1px 5px rgba(0,0,0,0.3); -moz-box-shadow:0 1px 5px rgba(0,0,0,0.3); box-shadow:0 1px 5px rgba(0,0,0,0.3);
  }
  .doc_editor textarea {
    width: 100%;
    height: 80%;
  }
  .doc_editor .expand_nav {
    color: #546e7a;
    font-size: 20px;
    line-height: 20px;
    position: absolute;
    top: 205px;
    left: -63px;
    background: white;
    border-radius: 5px 0px 0px 5px;
    border-right: none;
    -webkit-box-shadow: -1px 1px 3px rgba(0,0,0,0.3); -moz-box-shadow: -1px 1px 3px rgba(0,0,0,0.3); box-shadow: -1px 1px 3px rgba(0,0,0,0.3);
    cursor: pointer;
  }
  .doc_editor .expand_nav.btn-success { color: #fff; background: var(--success); }
  .doc_editor.expanded_nav, .doc_editor:hover { right: 0px; }

  .doc_nav ul {
    list-style: none;
    padding: 0;
    position: relative;
  }
  .doc_nav > ul {
    padding-bottom: 20px;
  }
  .doc_nav > ul h2 {
    padding: 15px 20px;
    color: #606f7b;
    font-size: 11px;
    margin-bottom: 0;
    font-weight: 700;
    text-transform: uppercase;
  }
  .doc_nav > ul h2 a {
    -webkit-transition: padding-left .3s;
    transition: padding-left .3s;
    color: #606f7b;
  }
  .doc_nav > ul h2 a:hover { padding-left: 5px; }
  .doc_nav > ul > li > ul { line-height: 2.25; }
  .doc_nav > ul > li > ul > li a {
    font-size: 14px;
    font-weight: 400;
    color: #989ea1;
    padding: 0 2rem;
    display: block;
    cursor: pointer;
    -webkit-transition: padding-left .3s;
    transition: padding-left .3s;

  }
  .doc_nav > ul > li > ul > li:hover a {
    padding-left: 2.3rem;
  }
  .doc_nav > ul > li > ul > li.is-active { padding-left: .5rem; }
  .doc_nav > ul > li > ul > li.is-active a { font-weight: 600; }
  .doc_nav > ul > li > ul > li.is-active:before {
    content: "";
    position: absolute;
    left: 0;
    z-index: 100;
    width: 2px;
    height: 30px;
    background: var(--theme);
  }

  .docs {
    position: relative;
    padding: 40px;
    padding-right: 280px;
    font-size: 16;
    font-weight: 400;
    color: #000;
  }
  .docs .docs_qnav {
    position: fixed;
    padding: 1rem;
    list-style: none;
    padding: 0;
    width: 200px;
    top: 200px;
    right: 60px;
    bottom: 65px;
    z-index: 100;
    overflow-y: auto;
  }
  .docs .docs_qnav li {
    border-width: 0px;
    border-bottom-width: 1px;
    border-style: dashed;
    border-color: #dae1e7;
    line-height: 1.5;
    padding: .75rem;
    background: white;
  }
  .docs .docs_qnav li a {
    font-size: .875rem;
    color: #b8c2cc;
  }
  .docs .docs_qnav li a:hover {
    color: var(--theme);
  }

  .docs ol > li, .docs ul > li {
    padding-top: .5rem;
    padding-bottom: .5rem;
  }
  /* .docs ol > li, .docs ul > li ul > li {
    padding-top: 0px;
    padding-bottom: 0px;
  } */

  .docs img { width: auto; max-width: 100%; }

  .docs table {
    background-color: var(--white);
    width: 100%;
    padding: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    -webkit-transition:all .1s ease-in-out; -moz-transition:all .1s ease-in-out; transition:all .1s ease-in-out;
    -webkit-box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
    -moz-box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
  }
  .docs table:hover {
    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
    -moz-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
  }
  .docs table td, .docs table th, .docs table tr {
    border: 1px solid #dae1e7;
    background-color: #fff;
    padding: 1rem;
    vertical-align: top;
  }
  .docs table tr:hover td {
    background-color: #eef0f3;
  }

  .docs .alert {
    position: relative;
    color: #fff;
    font-size: 16px;
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 30px 40px;
    border-radius: .5rem;
    border: none;
    overflow: hidden;
    -webkit-transition:all .1s ease-in-out; -moz-transition:all .1s ease-in-out; transition:all .1s ease-in-out;
    -webkit-box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
    -moz-box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
  }
  .docs .alert:hover {
    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
    -moz-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
  }
  .docs .alert.alert-danger { background-color: #f5365c; }
  .docs .alert.alert-warning { background-color: #fb6340; }
  .docs .alert.alert-info { background-color: #03a9f4; }
  .docs .alert.alert-primary { background-color: var(--theme); }
  .docs .alert.alert-default { background-color: #bbb; }
  .docs .alert.alert-success { background-color: #21b978; }
  .docs .alert i {
    position: absolute;
    width: 4rem;
    height: 4rem;
    opacity: .25;
    font-size: 50px;
    left: -4px;
    top: -4px;
  }

  .docs .progress { height: 20px; margin: 15px 0px; }
  .docs .progress > div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    background-color: #60bafd;
    -webkit-transition: width 0.6s ease;
    transition: width 0.6s ease;
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem;
    -webkit-animation: progress-bar-stripes 1s linear infinite;
    animation: progress-bar-stripes 1s linear infinite;
  }
  .docs .progress .danger { background-color: #f5365c; }
  .docs .progress .warning { background-color: #fb6340; }
  .docs .progress .info { background-color: #03a9f4; }
  .docs .progress .primary { background-color: var(--theme); }
  .docs .progress .default { background-color: #bbb; }
  .docs .progress .success { background-color: #21b978; }

  .docs pre {
    background: #344258!important;
    border-top: 3px solid var(--theme);
    color: #ccc;
    padding: 20px;
    border-radius: 5px;
    -webkit-box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
    -moz-box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,.08);
  }
  .docs pre:hover {
    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
    -moz-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.11), 0 1px 3px 0 rgba(0,0,0,.08);
  }

  .docs hr {
    border-top-width: 2px;
    border-style: dashed;
    border-color: #f1f5f8;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .docs h1, .doc_editor h1 {
    border-left: 2px solid var(--theme);
    padding-left: 1rem;
    margin-bottom: 1.5rem;
    font-weight: 700;
    font-size: 32px;
    color: #000;
  }

  .docs h2 {
    margin-top: 2.5rem;
    margin-bottom: 1rem;
    color: #606f7b;
    text-decoration: none;
    font-size: 23px;
    font-weight: 700;
  }
  .docs h2:before {
    content: "#";
    margin-left: -1rem;
    margin-top: .25rem;
    position: absolute;
    font-size: 1rem;
    color: var(--theme);
    opacity: .75;
  }
  .docs h3 {
    margin-top: 2.5rem;
    margin-bottom: 1rem;
    color: #000;
    font-size: 19px;
    font-weight: 700;
  }



</style>
